<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container d-flex flex-column">
        <header class="mdc-top-app-bar position-static">
          <div class="mdc-top-app-bar__row">
            <section
              class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
            >
              <!-- <a class="material-icons mdc-top-app-bar__navigation-icon" @click="closeSurvey()">close</a> -->
              <a
                class="material-icons mdc-top-app-bar__navigation-icon"
                @click="goBackToSurvey"
                >close</a
              >
            </section>

            <section class="mdc-top-app-bar__section title">
              <div class="mdc-top-app-bar__title">
                {{ $t("704") }}
                <!-- {{setTitle}} -->
                <!-- 설문 조사 -->
              </div>
            </section>

            <section
              class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
            >
              <a
                class="material-icons mdc-top-app-bar__action-item"
                aria-label="search"
                alt="search"
              ></a>
            </section>
          </div>
        </header>

        <section class="flex-grow-1 scroll-y pda-default">
          <!-- {{isFirstQuestion}}
                        -->
          <transition name="slide">
            <component
              v-if="questions[currentQuestionIndex]"
              ref="questionComp"
              :is="questions[currentQuestionIndex].type.value"
              :question="questions[currentQuestionIndex]"
              :setedAnswer="answers[questions[currentQuestionIndex].id]"
              :key="questions[currentQuestionIndex].id"
              @setAnswers="setAnswers"
            >
            </component>
          </transition>

          <!-- <CHOICE_SINGLE></CHOICE_SINGLE>
                    <CHOICE_MULTIPLE></CHOICE_MULTIPLE>
                    <SHORT_ANSWER></SHORT_ANSWER>
                    <STARS></STARS>
                    <RANKING></RANKING> -->
        </section>

        <section>
          <hr class="divider" />

          <div
            class="d-flex flex-row justify-content-between align-items-center pdt-10 pdb-44 pdl-10 pdr-10"
          >
            <button
              v-if="!isFirstQuestion"
              class="mdc-button btn-white"
              @click="prevQuestion()"
            >
              <i class="material-icons mdc-button__icon">keyboard_arrow_left</i>
              {{ $t("711") }}
            </button>
            <div v-else style="width: 64px"></div>
            <div style="color: #7a8692">
              <question-timer
                v-if="useTimeout"
                :time="timeout"
                @timerState="setTimerState"
                @timerEnd="timerSubmitSurvey"
                :key="timerTime"
              ></question-timer>
            </div>

            <button
              class="mdc-button btn-white"
              @click="nextQuestion()"
              v-if="!isLastQuestion"
            >
              {{ $t("712") }}
              <!-- 다음문항 -->
              <i class="material-icons mdc-button__icon"
                >keyboard_arrow_right</i
              >
            </button>

            <button
              class="mdc-button mdc-button--raised btn-red"
              @click="submitSurvey()"
              v-if="isLastQuestion"
            >
              {{ $t("715") }}
              <!-- 제출 -->
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 설문 응시 컴포넌트(survey take component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import Timer from "../exam/question/Timer.vue";
import { surveyMixin } from "@/mixins/survey.js";

export default {
  name: "surveyIntro",
  components: {
    "question-timer": Timer,
    SHORT_ANSWER: () => import("./question/ShortAnswer.vue"),
    CHOICE_SINGLE: () => import("./question/ChoiceSingle.vue"),
    CHOICE_MULTIPLE: () => import("./question/ChoiceMultiple.vue"),
    STARS: () => import("./question/Stars.vue"),
    RANKING: () => import("./question/Ranking.vue"),
  },

  mixins: [surveyMixin],

  data() {
    return {
      paper: null,
      questions: [],
      answers: {},
      currentQuestionIndex: 0,

      window: null,
      useTimeout: false,
      timeout: 0,
      eachViewFeedback: false,
      questionSequence: "",
      timerPauseState: false,
      timerTime: 0,
    };
  },

  created() {
    this.fatchData();
  },

  computed: {
    // is first question
    isFirstQuestion() {
      return this.currentQuestionIndex === 0 ? true : false;
    },

    // is last question
    isLastQuestion() {
      return this.currentQuestionIndex === this.questions.length - 1
        ? true
        : false;
    },
  },

  methods: {
    // 설문지 문항 정보 불러오기(set start / get survey data)
    fatchData() {
      let params = {
        respondentId: this.$route.params.respondentId,
      };

      // set survey start
      surveyApi
        .surveyRespondentStart(params)
        .then((response) => {
          // console.log('surveyRespondentStart', response.data.data);
          // get survey paper information
          return surveyApi.surveyRespondentWindow(params);
        })
        .then((response) => {
          // console.log('surveyRespondentWindow', response.data.data);
          this.window = response.data.data;
          this.useTimeout = this.window.useTimeout;
          this.timeout = this.window.timeout;
          this.eachViewFeedback = this.window.eachViewFeedback;
          this.questionSequence = this.window.questionSequence;

          // get survey question & set data
          surveyApi.surveyRespondentGroups(params).then((response) => {
            console.log("surveyRespondentGroups", response.data.data);

            this.paper = response.data.data;

            let number = 1;
            _.each(this.paper, (group, groupIndex) => {
              _.each(group.questions, (question, questionIndex) => {
                question.essential = group.essential;
                question.number = number++;

                this.questions.push(question);
              });
            });
            this.initAnswers();
          });
        });
    },

    // 타이머 만료시 동작(popup when timer expires)
    timerSubmitSurvey() {
      this.$confirm({
        title: this.$t("720"), //설문 응답 시간 만료
        content: this.$t("721") + "<br>" + this.$t("751"), //제한된 응답 시간이 만료되었습니다. 설문 종료 시 현재까지 응답한 내용만 제출됩니다.
        accept: this.$t("723"), //재응답하기
        cancel: this.$t("722"), //설문 종료
      })
        .then(() => {
          this.timerTime++;
          this.$router.push(
            `/independent/survey/${this.$route.params.distId}/${this.$route.params.respondentId}/intro`
          );
        })
        .catch(() => {
          this.moveSurveyView();
        });
    },

    // 설문 제출(submit survey)
    submitSurvey() {
      if (
        this.questions[this.currentQuestionIndex].type.value == "SHORT_ANSWER"
      ) {
        let getValidated = this.$refs.questionComp.validateTextArea();
        if (getValidated) {
          this.submitSurveyPart();
        }
      } else {
        this.submitSurveyPart();
      }
    },

    // This method belong to submit function
    submitSurveyPart() {
      let isSolved = this.answers[this.questions[this.currentQuestionIndex].id]
        .isSolved;
      let essential = this.questions[this.currentQuestionIndex].essential;

      if (essential) {
        if (isSolved) {
          //
          let distId = this.$route.params.distId;
          let respondentId = this.$route.params.respondentId;

          let params = {
            respondentId: respondentId,
            answers: this.answers,
          };
          surveyApi
            .surveyRespondentSubmit(params)
            .then((response) => {
              let closeMessage = response.data.data.closeMessage;
              this.$alert({
                content: this.$t("3058"),
                accept: this.$t("3059"),
              })
                .then(() => {
                  if (this.$route.query.distributionType == "SATISFACTION") {
                    this.$router.push(
                      "/learn/" +
                        this.$route.query.learnId +
                        "?status=" +
                        this.$route.query.status +
                        "&tab=viewSurvey"
                    );
                  } else {
                    this.$router.push({
                      name: "IndependentSurveyResult",
                      params: {
                        distId: distId,
                        respondentId: respondentId,
                      },
                      query: {
                        status: this.$route.query.status,
                        learnId: this.$route.query.learnId,
                        distributionType: this.$route.query.distributionType,
                      },
                    });
                  }
                })
                .catch(() => {
                  //this.$router.push('/login')
                });
            })
            .catch((err) => {
              let responseData = err.response.data.meta;
              let alertMessage = this.$t(
                "TODO-설문지 제출 중 오류가 발생하였습니다. 다시 참여해 주시기 바랍니다."
              );
              if (responseData.errCode === 2201) {
                alertMessage = this.$t("TODO-이미 참여한 설문지 입니다."); // this.$t('TODO-이미 재출한 시험지 입니다.')
              }

              this.$alert({
                content: alertMessage,
                accept: this.$t("TODO-확인"),
              }).then(() => {
                if (this.$route.query.distributionType == "SATISFACTION") {
                  this.$router.push(
                    "/learn/" +
                      this.$route.query.learnId +
                      "?status=" +
                      this.$route.query.status +
                      "&tab=viewSurvey"
                  );
                } else {
                  this.$router.push({
                    name: "IndependentSurveyTotalView",
                    params: { distId: this.$route.params.distId },
                    query: this.$route.query,
                  });
                }
              });
            });
          //
        } else {
          this.$snackOpen({
            contents: this.$t("756"), //필수 질문에 응답해주세요.
            btnDisplayYN: true,
            btnDisplay: this.$t("757"), // 확인
          }).then(() => {});
        }
      } else {
        //
        let distId = this.$route.params.distId;
        let respondentId = this.$route.params.respondentId;

        let params = {
          respondentId: respondentId,
          answers: this.answers,
        };
        surveyApi
          .surveyRespondentSubmit(params)
          .then((response) => {
            let closeMessage = response.data.data.closeMessage;
            this.$alert({
              content: this.$t("3058"),
              accept: this.$t("3059"),
            })
              .then(() => {
                if (this.$route.query.distributionType == "SATISFACTION") {
                  this.$router.push(
                    "/learn/" +
                      this.$route.query.learnId +
                      "?status=" +
                      this.$route.query.status +
                      "&tab=viewSurvey"
                  );
                } else {
                  this.$router.push({
                    name: "IndependentSurveyResult",
                    params: {
                      distId: distId,
                      respondentId: respondentId,
                    },
                    query: {
                      status: this.$route.query.status,
                      learnId: this.$route.query.learnId,
                      distributionType: this.$route.query.distributionType,
                    },
                  });
                }
              })
              .catch(() => {
                //this.$router.push('/login')
              });
          })
          .catch((err) => {
            let responseData = err.response.data.meta;
            let alertMessage = this.$t("3078"); //'TODO-시험지 제출 중 오류가 발생하였습니다. 다시 응시해 주시기 바랍니다.'
            if (responseData.errCode === 2201) {
              alertMessage = this.$t("TODO-이미 참여한 설문지 입니다."); // this.$t('TODO-이미 재출한 시험지 입니다.')
            }

            this.$alert({
              content: alertMessage,
              accept: this.$t("3079"),
            }).then(() => {
              if (this.$route.query.distributionType == "SATISFACTION") {
                this.$router.push(
                  "/learn/" +
                    this.$route.query.learnId +
                    "?status=" +
                    this.$route.query.status +
                    "&tab=viewSurvey"
                );
              } else {
                this.$router.push({
                  name: "IndependentSurveyTotalView",
                  params: { distId: this.$route.params.distId },
                  query: this.$route.query,
                });
              }
            });
          });
        //
      }
    },

    // 다음 문항으로 이동(Go to the next question)
    nextQuestion() {
      if (
        this.questions[this.currentQuestionIndex].type.value == "SHORT_ANSWER"
      ) {
        let getValidated = this.$refs.questionComp.validateTextArea();
        console.log("getValidated", getValidated);
        if (getValidated) {
          let isSolved = this.answers[
            this.questions[this.currentQuestionIndex].id
          ].isSolved;

          let essential = this.questions[this.currentQuestionIndex].essential;

          if (essential) {
            if (isSolved) {
              this.currentQuestionIndex++;
            } else {
              this.$snackOpen({
                contents: this.$t("756"), //필수 질문에 응답해주세요.
                btnDisplayYN: true,
                btnDisplay: this.$t("757"), // 확인
              }).then(() => {});
            }
          } else {
            this.currentQuestionIndex++;
          }
        }
      } else {
        let isSolved = this.answers[
          this.questions[this.currentQuestionIndex].id
        ].isSolved;

        let essential = this.questions[this.currentQuestionIndex].essential;

        if (essential) {
          if (isSolved) {
            this.currentQuestionIndex++;
          } else {
            this.$snackOpen({
              contents: this.$t("756"), //필수 질문에 응답해주세요.
              btnDisplayYN: true,
              btnDisplay: this.$t("757"), // 확인
            }).then(() => {});
          }
        } else {
          this.currentQuestionIndex++;
        }
      }
    },

    // 이전 문항으로 이동(Go to the prev question)
    prevQuestion() {
      this.currentQuestionIndex--;
    },

    // 타이머 상태 업데이트(Timer status update)
    setTimerState(state) {
      this.timerPauseState = state;
    },

    // 설문 문항 답안 설정(set answer)
    setAnswers(answer) {
      this.answers[answer.questionId] = {
        text: answer.text,
        comment: answer.comment,
        selected: answer.selected,
        weight: answer.weight,
        isSolved: answer.isSolved,
      };
    },

    // 설문 문항 답안 초기화(init answer)
    initAnswers() {
      _.each(this.questions, (question) => {
        let defaultSelected = [];
        let defaultWeight = {};

        if (
          question.type.value === "CHOICE_SINGLE" ||
          question.type.value === "CHOICE_MULTIPLE"
        ) {
          defaultSelected = _(question.choices.length).times(() => {
            return false;
          });
        } else if (question.type.value === "RANKING") {
          _.each(question.choices, (choice) => {
            defaultWeight[String(choice.id)] = 0;
          });
        }

        this.answers[question.id] = {
          text: "",
          comment: "",
          selected: defaultSelected,
          weight: defaultWeight,
          isSolved: false,
        };
      });
    },
    goBackToSurvey() {
      this.$confirm({
        title: this.$t("716"), //설문 응답을 종료하시겠습니까?
        content: this.$t("717"), //설문 응답 종료 시 현재까지 응답한 내용은 제출되지 않습니다.
        accept: this.$t("719"), //확인
        cancel: this.$t("718"), //취소
      })
        .then(() => {
          if (this.$route.query.distributionType == "SATISFACTION") {
            this.$router.push(
              "/learn/" +
                this.$route.query.learnId +
                "?status=" +
                this.$route.query.status +
                "&tab=viewSurvey"
            );
          } else {
            this.$router.push({
              name: "IndependentSurveyTotalView",
              params: { distId: this.$route.params.distId },
              query: this.$route.query,
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>